import { InjectionToken } from "@angular/core";
import { TelemetryConfig } from "./config";

export const TELEMETRY_CONFIGS = new InjectionToken<TelemetryConfig>("@dcc/user-telemetry configs");
